// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__iTa4U","modalFooterButton":"ModalNotes_modalFooterButton__2uKmc"};